import React, { useState } from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import { supabase } from '../../supabaseClient';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      window.location.href = '/app/dashboard';
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError('Please enter your email address first.');
      return;
    }
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/password-reset`,
      });
      if (error) throw error;
      alert('Password reset email sent! Check your inbox.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Log in to your Categorizer account"
      footer={<>
        Don’t have an account? <a href="/register">Register</a>
      </>}
    >
      <form onSubmit={handleLogin}>
        <label className="label" htmlFor="email">Email</label>
        <input className="input" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />

        <label className="label" htmlFor="password">Password</label>
        <input className="input" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />

        {error && <div style={{ color: '#ff6b6b', fontSize: 14 }}>{error}</div>}

        <div className="auth-actions">
          <button className="button full" type="submit" disabled={loading}>{loading ? 'Logging in…' : 'Log in'}</button>
          <button type="button" className="button secondary full" onClick={handlePasswordReset}>Forgot password</button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login; 